import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { FUNCTION_RESULT_STATUS } from "@nova/common-interfaces";
import { IInvoice } from "@rfm/shared-interfaces";
import { BlockUIModule } from "ng-block-ui";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { MenuModule } from "primeng/menu";
import { TableModule } from "primeng/table";
import { CommonComponent } from "../../../../../../lib/components/common/common.component.mjs";
import { InvoiceService } from "../../../../../shared/services/financial/invoice.service.mjs";

@Component({
  selector: "app-invoices-card",
  standalone: true,
  imports: [
    CommonModule,
    BlockUIModule,
    CardModule,
    TableModule,
    ButtonModule,
    ConfirmDialogModule,
    MenuModule,
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: "./invoice-card.component.html",
  styleUrls: ["./invoice-card.component.scss"],
})
export class InvoiceCardComponents extends CommonComponent {
  @Input()
  invoices: IInvoice[] = [];

  items: MenuItem[] = [
    {
      label: "View",
      icon: "pi pi-file",
      command: () => this.view(this.selectedInvoice!.id),
    },
    {
      label: "Download",
      icon: "pi pi-download",
      command: () => this.download(this.selectedInvoice!.document_url),
    },
    {
      label: "Mark Paid",
      icon: "pi pi-dollar",
      command: () => this.markPaid(this.selectedInvoice!.id),
    }
  ];

  async markPaid(invoice_id: string) {
    this.confirmationService.confirm({
      target: event!.target as EventTarget,
      message: "Are you sure that you want to mark this invoice as paid?",
      header: "Mark Invoice Paid",
      closable: true,
      closeOnEscape: true,
      icon: "pi pi-exclamation-triangle",
      rejectButtonProps: {
        label: "Cancel",
        severity: "secondary",
        outlined: true,
      },
      acceptButtonProps: {
        label: "Mark Invoice Paid",
        severity: "primary",
      },
      accept: async () => {
        this.isLoading(true);
        
        this.invoiceService
          .markPaid(invoice_id)
          .then((result) => {
            if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
              this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Invoice marked as paid ....",
              });
            } else {
              this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Failed to mark invoice paid ....",
              });
            }
          })
          .finally(() => {
            this.isLoading(false);
          });
      },
    });
  }

  view(invoice_id: string) {
    this.router.navigate(["/admin/invoices/view/", invoice_id]);
  }

  download(document_url: string | undefined) {
    if (document_url) {
      window.open(document_url, "_blank");
    }
  }

  constructor(
    protected router: Router,
    protected invoiceService: InvoiceService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {
    super();
  }

  selectedInvoice: IInvoice | undefined;

  rowSelected() {
    console.log("Customer", this.selectedInvoice);
    this.router.navigate(["/admin/customers/view/", this.selectedInvoice?.id]);
  }
}
